import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_BASE_URL!,
  realm: import.meta.env.VITE_KEYCLOAK_REALM!,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID!,
};


if (!keycloakConfig.url || !keycloakConfig.realm || !keycloakConfig.clientId) {

  throw new Error(
    'Keycloak configuration is missing. Ensure VITE_KEYCLOAK_BASE_URL, VITE_KEYCLOAK_REALM, and VITE_KEYCLOAK_CLIENT_ID are set in your .env file.',
  );
}

const keycloak = new Keycloak(keycloakConfig);

export const initKeycloak = (onAppReadyCallback: () => void) => {
  // Public form routes (/forms/*) must be accessible without login.
  // Skipping onLoad for these paths prevents Keycloak from redirecting unauthenticated
  // visitors to the login page before React even mounts.
  const isPublicFormRoute = window.location.pathname.startsWith('/forms/')

  keycloak
    .init({
      ...(isPublicFormRoute ? {} : { onLoad: 'login-required' }),
      pkceMethod: 'S256',
      checkLoginIframe: false,
    })
    .then(() => {
      if (keycloak.authenticated) {
        // Background token refresh check: every 5 minutes (300,000 ms)
        // Refresh the token if it will expire within the next 310 seconds (5 mins + 10s buffer)
        setInterval(() => {
          keycloak.updateToken(310).catch(() => {});
        }, 300000);

        // Tab Visibility listener: check token validity immediately when user returns to the tab
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            keycloak.updateToken(70).catch(() => {});
          }
        });
      }

      onAppReadyCallback();
    })
    .catch(() => {
      onAppReadyCallback();
    });
};

export default keycloak;